import { render, staticRenderFns } from "./EmergenciasActivasPage.vue?vue&type=template&id=7283ada8&"
import script from "./EmergenciasActivasPage.vue?vue&type=script&lang=js&"
export * from "./EmergenciasActivasPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports